import { observer } from 'mobx-react';
import { ParticipantResource } from '../../../../../../../ParticipantsStore/Types';
import VerticalMenuIcon from '../../../../../../Cutesies/VerticalMenuIcon';
import ActionItems from '../../../../../Groups/Table/ActionItems';
import LastLoginAt from '../../../../../Shared/LastLoginAt';
import { GroupParticipantsResource } from '../../../../GroupParticipantsStore/Types';
import RemoveParticipant from './RemoveParticipant';
import RemoveParticipantModal from './RemoveParticipant/Modal';
import RemoveParticipantStore from './RemoveParticipant/RemoveParticipantStore/Store';

interface Props {
  resource: ParticipantResource;
  groupParticipantsResource: GroupParticipantsResource;
  store: RemoveParticipantStore;
}

function RowBody({ resource, groupParticipantsResource, store }: Props) {
  const { payload } = resource;
  switch (store.state.kind) {
    case 'deleted':
      return <></>;
    case 'failure':
    case 'success':
    case 'ready':
    case 'waiting':
    case 'error':
    case 'deleting':
      return (
        <tr>
          <td className="hidden whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 md:table-cell">
            {payload.fullName.getOrElseValue('')}
          </td>
          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{payload.email}</td>
          <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell">
            {payload.preferredLanguage.getOrElseValue('')}
          </td>
          <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell">
            {payload.loginCount}
          </td>
          <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 xl:table-cell">
            <LastLoginAt lastLoginAt={payload.lastLoginAt} />
          </td>
          <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell">
            {payload.userGroupsCount}
          </td>
          <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell">
            {payload.collections.length}
          </td>
          <td>
            <ActionItems
              icon={<VerticalMenuIcon />}
              content={
                <RemoveParticipant
                  store={store}
                  participant={resource}
                  groupParticipantsResource={groupParticipantsResource}
                />
              }
            />
            <RemoveParticipantModal store={store} />
          </td>
        </tr>
      );
  }
}
export default observer(RowBody);
